'use strict';

export default function routes($stateProvider) {
  'ngInject';
  $stateProvider.state('formation', {
    url: '/formation/:id',
    template: '<formation></formation>',
    authenticate: true
  });
}



// WEBPACK FOOTER //
// ./client/app/formation/formation.routes.js